import { useTranslation } from 'react-i18next'

import { useProgramStates } from '../../hooks/useProgramStates/useProgramStates'

import { mapHistoryToTimeline } from './candidateTimeline.utils'
import { useQuery } from '@percent/partner-dashboard/common/hooks'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export type UseCandidateTimelineParams = {
  programId: string
  candidateId: string
}

export const useCandidateTimeline = ({ programId, candidateId }: UseCandidateTimelineParams) => {
  const { t, i18n } = useTranslation()
  const { grantsService } = useServices()

  const [{ data, isLoading, error }] = useQuery(grantsService.getCandidateHistory, { programId, candidateId })

  // Hidden states still need naming: a candidate can have moved through one.
  const { unmappedStates, isLoading: areStatesLoading } = useProgramStates({ programId, filterNullvalues: false })

  const stateNames = Object.fromEntries(
    unmappedStates.map(state => [state.id, state.displayKey ?? state.displayGroup ?? state.id])
  )

  // A task-driven condition records the task template it waited on, so the program's own states are
  // what turn it into a name a partner recognises.
  const taskNames = Object.fromEntries(
    unmappedStates
      .flatMap(state => state.taskTemplates ?? [])
      .filter(template => template.name)
      .map(template => [template.id, template.name as string])
  )

  return {
    items: mapHistoryToTimeline({ entries: data?.entries ?? [], stateNames, taskNames, locale: i18n.language, t }),
    isLoading: isLoading || areStatesLoading,
    error
  }
}
